import { GenericFilterProps } from "PFApp/components/filters_v2/types";
import { FetchFilterOptionsResponse } from "PFCore/services/filters/fetch_filter_options";
import { ComponentType } from "react";

import { Id } from "../id";
import { ApiFilterGroupV2, FilteredCollectionKey, FilterKeyV2, FilterPathV2 } from "./filter_key";
import { FilterOptionsQueryParams } from "./misc";
import { FilterOptionV2, FilterValueV2 } from "./values";

export enum FilterTypeV2 {
  Radio = "radio_buttons",
  Search = "search",
  SelectMany = "select_many",
  Checkboxes = "checkboxes",
  SelectOne = "select_one",
  String = "string",
  Integer = "integer",
  Availability = "availability",
  AvailabilityRange = "availability_range",
  DateRange = "date_range",
  ReportingRange = "reporting_range",
  Date = "date",
  ToggleCheckbox = "toggle_checkbox",
  Number = "number",
  Hidden = "hidden"
}

export type FilterV2OptionsFetch = (params: FilterOptionsQueryParams) => Promise<FetchFilterOptionsResponse>;

export type FilterComputedPropertiesV2 = {
  originalPath: FilterPathV2;
  group: ApiFilterGroupV2;
  collection: FilteredCollectionKey;
  defaultValue?: FilterValueV2 | null;
  isChildren?: boolean;
  optionsQuery?: FilterV2OptionsFetch;
  InputComponent?: ComponentType<GenericFilterProps>;
  inputStyle?: Partial<{ fullWidth: boolean }>;
  required?: boolean; // in future this param will be sent from API
  disabled?: boolean;
  error?: string | null;
  limit?: number | null; // number of entries in returned collection above which filter gets excluded from the search
};

export type StandardFilterV2 = FilterComputedPropertiesV2 & {
  type: FilterTypeV2;
  value: FilterValueV2;
  title: string;
  name: FilterKeyV2;
  text?: string;
  hidden?: boolean | null;
  operator?: string;
  ordinal?: number;
  facets?: boolean;
  important?: boolean;
  templateKey?: Id;
  entityName?: "profile" | string;
  segment?: boolean;
};

export type OptionsFilterV2 = StandardFilterV2 & {
  options: FilterOptionV2[];
};

type NumberFilterStatisticsV2 = {
  statistics: { min: number; max: number };
};

export type NumberFilterV2 = Omit<StandardFilterV2, "query"> &
  NumberFilterStatisticsV2 & {
    statistics: { min: number; max: number };
    query: ({ value, term }) => Promise<NumberFilterStatisticsV2>;
  };

export type PeriodFilterV2 = StandardFilterV2 & {
  period?: string;
};

export type FilterV2 = StandardFilterV2 | OptionsFilterV2 | PeriodFilterV2 | NumberFilterV2;

export type AnyFilterV2 = StandardFilterV2 & OptionsFilterV2 & PeriodFilterV2 & NumberFilterV2;

export type FilterV2WithValueOnly = Pick<FilterV2, "value" | "originalPath" | "isChildren">;
export type FilterV2WithValueAndDefault = Pick<
  FilterV2,
  "value" | "defaultValue" | "originalPath" | "isChildren"
>;
